/* Kit Skincare Antiacne: comportamento das secoes novas e dos dois blocos da
   caixa de compra. Nao toca no resto da pagina do tema. */
(function () {
  "use strict";
  // ?captura desliga a entrada animada (fotos da pagina inteira)
  if (!/captura/.test(location.search)) document.documentElement.classList.add("ac-js");
  var menos = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var anima = document.documentElement.classList.contains("ac-js") && !menos;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  // cada secao do design system carrega este arquivo: roda uma vez so
  if (window.weupHbDs) return; window.weupHbDs = true;
  var raiz = document;

  // ---- entrada: condensa assim que o topo do elemento passa de 1/5 da tela, sem atraso
  var obs = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add("dentro");
      obs.unobserve(e.target);
    });
  }, { rootMargin: "0px 0px -20% 0px", threshold: 0 });
  // celular (29/09, "trava" e "o borrao de entrada demora pra renderizar"): peca com
  // vidro dentro nao entra animada. Enquanto ela se move, o celular refaz o desfoque de
  // todos os vidros dela a cada quadro (medido: 70% do trabalho de GPU na rolagem). Ela
  // ja nasce pronta ("pronta"); o observador segue marcando "dentro" na hora certa, para
  // a maozinha e o icone da linha do tempo. Titulos e fotos seguem entrando. Desktop igual.
  var toque = window.matchMedia("(hover: none), (max-width: 899px)").matches;
  var vidro = function (el) { var c = getComputedStyle(el), v = c.backdropFilter || c.webkitBackdropFilter; return !!v && v !== "none"; };
  $$(".surge", raiz).forEach(function (el) {
    if (toque && (vidro(el) || $$("*", el).some(vidro))) el.classList.add("pronta");
    obs.observe(el);
  });

  // celular (29/09, teste pixel a pixel): vidro GRANDE sem foto nem video atras nao
  // precisa do desfoque. Atras dele so ha branco e as luzes, que ja sao suaves: com
  // so o realce de cor (saturate) fica igual a olho nu, e o celular para de refazer o
  // desfoque dessas areas a cada quadro da rolagem. Vidro sobre foto (legendas, play,
  // setas da galeria, selos) e vidro pequeno ficam como estao. Quais pecas tem vidro
  // sai das proprias folhas de estilo do DS (vale para secao nova sem lista a manter).
  if (toque) {
    var seletores = function () {
      var sel = [];
      var varre = function (regras) {
        for (var i = 0; i < regras.length; i++) {
          var r = regras[i];
          if (r.cssRules && !r.selectorText) varre(r.cssRules);
          else if (r.style) {
            var v = r.style.getPropertyValue("backdrop-filter") || r.style.getPropertyValue("-webkit-backdrop-filter");
            if (v && v !== "none" && r.selectorText.indexOf("::") === -1) sel.push(r.selectorText);
          }
        }
      };
      [].forEach.call(document.styleSheets, function (s) {
        if (!/weup-hb-ds/.test(s.href || "")) return;
        try { varre(s.cssRules); } catch (e) {}
      });
      return sel.join(",");
    };
    var alivia = function () {
      var sel = seletores(); if (!sel) return;
      var fotos = $$("img, video, picture, canvas", raiz).map(function (f) { return { el: f, r: f.getBoundingClientRect() }; })
        .filter(function (f) { return f.r.width > 0 && f.r.height > 0; });
      var temFotoAtras = function (el, r) {
        var area = r.width * r.height;
        for (var i = 0; i < fotos.length; i++) {
          var f = fotos[i]; if (el.contains(f.el)) continue;
          var w = Math.min(r.right, f.r.right) - Math.max(r.left, f.r.left), h = Math.min(r.bottom, f.r.bottom) - Math.max(r.top, f.r.top);
          if (w > 0 && h > 0 && w * h > area * 0.03) return true;
        }
        for (var a = el.parentElement, n = 0; a && a !== document.body && n < 8; a = a.parentElement, n++) {
          if (/url\(/.test(getComputedStyle(a).backgroundImage)) return true;
        }
        return false;
      };
      $$(sel).forEach(function (el) {
        var c = getComputedStyle(el), v = c.backdropFilter || c.webkitBackdropFilter;
        if (!v || v.indexOf("blur") === -1) return;
        var r = el.getBoundingClientRect();
        if (r.width * r.height < 20000 || temFotoAtras(el, r)) return;
        var sem = v.replace(/blur\([^)]*\)/g, "").trim() || "none";
        el.style.setProperty("backdrop-filter", sem, "important");
        el.style.setProperty("-webkit-backdrop-filter", sem, "important");
        el.classList.add("vidro-leve");
      });
    };
    if (document.readyState === "complete") alivia(); else addEventListener("load", alivia);
  }

  // ---- luzes: so derivam com a secao na tela
  if (anima) {
    var obsL = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle("viva", e.isIntersecting); }); });
    $$(".luzes", raiz).forEach(function (el) { obsL.observe(el); });
  }

  // ---- cartoes que expandem no lugar
  $$(".beneficio, .produto, .ativo-card", raiz).forEach(function (b) {
    b.addEventListener("click", function () { b.setAttribute("aria-expanded", b.getAttribute("aria-expanded") === "true" ? "false" : "true"); });
  });

  // ---- faixas que rolam de lado: setas, veu so do lado com conteudo, arraste com mouse
  function bordas(f) {
    f.classList.toggle("fade-e", f.scrollLeft > 4);
    f.classList.toggle("fade-d", f.scrollWidth - f.clientWidth - f.scrollLeft > 4);
  }
  function arrasta(el) {
    var x0 = 0, s0 = 0, ativo = false, moveu = false;
    el.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse" || e.button !== 0) return; ativo = true; moveu = false; x0 = e.clientX; s0 = el.scrollLeft; });
    addEventListener("pointermove", function (e) {
      if (!ativo) return; var dx = e.clientX - x0;
      if (!moveu && Math.abs(dx) > 5) { moveu = true; el.classList.add("arrastando"); }
      if (moveu) el.scrollLeft = s0 - dx;
    });
    addEventListener("pointerup", function () {
      if (!ativo) return; ativo = false;
      if (moveu) {
        var l = el.scrollLeft; el.classList.remove("arrastando"); el.scrollLeft = l;
        var bloqueia = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
        el.addEventListener("click", bloqueia, { capture: true, once: true });
        setTimeout(function () { el.removeEventListener("click", bloqueia, { capture: true }); }, 60);
      }
    });
  }
  $$(".faixa", raiz).forEach(function (fx) {
    var t = $("[data-faixa]", fx);
    var passo = function () { var c = t.firstElementChild; return c.getBoundingClientRect().width + 12; };
    var ant = $("[data-faixa-ant]", fx), prox = $("[data-faixa-prox]", fx);
    if (ant) ant.addEventListener("click", function () { t.scrollBy({ left: -passo(), behavior: menos ? "auto" : "smooth" }); });
    if (prox) prox.addEventListener("click", function () { t.scrollBy({ left: passo(), behavior: menos ? "auto" : "smooth" }); });
    function pinta() { bordas(t); if (ant) ant.disabled = t.scrollLeft <= 4; if (prox) prox.disabled = t.scrollWidth - t.clientWidth - t.scrollLeft <= 4; }
    t.addEventListener("scroll", pinta, { passive: true }); addEventListener("resize", pinta); pinta();
    arrasta(t);
  });

  // ---- linha do tempo: trilha do centro do 1o marco ao do ultimo; enche com a rolagem
  var lista = $("[data-tempo]", raiz);
  if (lista) {
    var trilha = $(".tempo__trilha", lista), fill = $(".tempo__trilha i", lista), etapas = $$(".etapa", lista);
    var trilho = function () {
      var m = $$(".etapa__marco", lista); if (!m.length) return;
      var lr = lista.getBoundingClientRect(), a = m[0].getBoundingClientRect(), z = m[m.length - 1].getBoundingClientRect();
      trilha.style.setProperty("--t-topo", (a.top + a.height / 2 - lr.top) + "px");
      trilha.style.setProperty("--t-base", (lr.bottom - (z.top + z.height / 2)) + "px");
    };
    var pedT = false, ultProg = "";
    var pintaT = function () {   // no quadro de desenho: le tudo, depois escreve so o que mudou (desempenho, 29/09)
      pedT = false;
      var r = lista.getBoundingClientRect(), meio = innerHeight * 0.55;
      var acesas = etapas.map(function (et) { return et.getBoundingClientRect().top + 28 < meio; });
      var prog = Math.max(0, Math.min(1, (meio - r.top) / r.height)).toFixed(3);
      if (prog !== ultProg) { fill.style.setProperty("--prog", prog); ultProg = prog; }
      etapas.forEach(function (et, k) { if (et.classList.contains("acesa") !== acesas[k]) et.classList.toggle("acesa", acesas[k]); });
    };
    trilho(); addEventListener("resize", trilho); if (document.fonts) document.fonts.ready.then(trilho);
    addEventListener("scroll", function () { if (!pedT) { pedT = true; requestAnimationFrame(pintaT); } }, { passive: true }); pintaT();
  }

  // ---- o ciclo: as quatro etapas travam uma a uma quando o widget aparece
  var ciclo = $("[data-ciclo]", raiz);
  if (ciclo) {
    var trava = function () { $$(".ciclo__etapa", ciclo).forEach(function (et, k) { setTimeout(function () { et.classList.add("travada"); }, anima ? 350 + k * 420 : 0); }); };
    if (!anima) trava();
    else new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { o.disconnect(); trava(); } }, { threshold: 0.6 }).observe(ciclo);
  }

  // ---- odometro: cada digito numa casa fixa; prefixo e sufixo fixos
  $$("[data-odo]", raiz).forEach(function (el) {
    var fim = String(el.dataset.odo), pre = el.dataset.prefixo || "", suf = el.dataset.sufixo || "";
    el.textContent = "";
    // prefixo de texto (ex.: FPS) fica pequeno; simbolo (ex.: +) tem o tamanho do numero
    if (pre) { var p = document.createElement("span"); var simbolo = !/[A-Za-z0-9]/.test(pre); p.className = simbolo ? "odo__pre" : "odo__suf"; if (!simbolo) p.style.margin = "0 4px 0 0"; p.textContent = pre.trim(); p.setAttribute("aria-hidden", "true"); el.appendChild(p); }
    fim.split("").forEach(function (d, k) {
      var casa = document.createElement("span"); casa.className = "odo__casa"; casa.setAttribute("aria-hidden", "true");
      var fita = document.createElement("span"); fita.className = "odo__fita";
      for (var n = 0; n <= 9; n++) { var c = document.createElement("span"); c.textContent = n; fita.appendChild(c); }
      fita.dataset.alvo = d; fita.style.transitionDelay = (k * 120) + "ms";
      if (!anima) fita.style.transform = "translateY(" + (-d * 10) + "%)";
      casa.appendChild(fita); el.appendChild(casa);
    });
    if (suf) { var s = document.createElement("span"); s.className = "odo__suf"; s.textContent = suf; s.setAttribute("aria-hidden", "true"); el.appendChild(s); }
  });
  if (anima) {
    var obsN = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; obsN.unobserve(e.target);
        $$(".odo__fita", e.target).forEach(function (f) { f.style.transform = "translateY(" + (-f.dataset.alvo * 10) + "%)"; });
      });
    }, { threshold: 0.6 });
    $$("[data-odo]", raiz).forEach(function (el) { obsN.observe(el); });
  }

  // ---- FAQ: acordeao; a foto guarda a altura das perguntas fechadas
  $$(".aba__botao", raiz).forEach(function (b) {
    b.addEventListener("click", function () { b.setAttribute("aria-expanded", b.getAttribute("aria-expanded") === "true" ? "false" : "true"); });
  });
  var faqLado = $(".faq__lado", raiz), faqFoto = $(".faq__foto", raiz);
  var medeFaq = function () { if ($$(".faq__lado .aba__botao[aria-expanded='true']", raiz).length) return; faqFoto.style.setProperty("--faq-h", faqLado.offsetHeight + "px"); };
  if (faqLado && faqFoto) { medeFaq(); addEventListener("resize", medeFaq); if (document.fonts) document.fonts.ready.then(medeFaq); }

  // ---- botoes "comprar": levam ate a caixa de compra do ar e destacam o botao dela
  var btnCompra = $("main-product buy-button") || $("main-product .tc-bundle .tc-cta") || $("buy-button") || $(".buy-button__wrapper");
  $$("[data-comprar]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault(); if (!btnCompra) return;
      if (st && st.open) st.close();
      // falta escolher a cor: a propria caixa leva ate a cor que falta, nao ate o botao desligado
      var ctaCaixa = bundle && bundle.querySelector(".tc-cta");
      if (ctaCaixa && ctaCaixa.disabled && !bundle.hasAttribute("data-esgotado")) { bundle.dispatchEvent(new CustomEvent("tc:pede-cor")); return; }
      btnCompra.scrollIntoView({ behavior: menos ? "auto" : "smooth", block: "center" });
      if (!menos && btnCompra.animate) btnCompra.animate([{ transform: "scale(1)" }, { transform: "scale(1.05)" }, { transform: "scale(1)" }], { duration: 700, delay: 500, easing: "cubic-bezier(0.16,1,0.3,1)" });
    });
  });

  // ---- barra fixa: so depois que o botao da caixa de compra saiu da tela por cima
  var barra = $("[data-ac-barra]"), pedida = false;
  function barraPos() {
    pedida = false; if (!barra || !btnCompra) return;
    var passou = btnCompra.getBoundingClientRect().bottom < 0;
    if (passou === barra.classList.contains("visivel")) return;
    barra.classList.toggle("visivel", passou); barra.setAttribute("aria-hidden", String(!passou));
    document.documentElement.classList.toggle("ac-barra-on", passou);
  }
  addEventListener("scroll", function () { if (!pedida) { pedida = true; requestAnimationFrame(barraPos); } }, { passive: true });
  addEventListener("resize", barraPos); barraPos();

  // ---- a barra (e a do player) acompanham o seletor de quantidade da caixa:
  // o tema grava a quantidade em data-quantity do <buy-button>
  var moeda = function (c) { return "R$ " + (c / 100).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."); };
  function quantidade() {
    var q = parseInt(btnCompra && btnCompra.getAttribute("data-quantity"), 10) || 1;
    $$("[data-barra-qtd]").forEach(function (el) { el.textContent = q + (q > 1 ? " unidades" : " unidade"); });
    $$("[data-barra-valores]").forEach(function (el) {
      var p = +el.dataset.preco, d = +el.dataset.de || 0;
      $("[data-barra-preco]", el).textContent = moeda(p * q);
      var s = $("[data-barra-de]", el); if (s && d) s.textContent = moeda(d * q);
    });
  }
  if (btnCompra && btnCompra.tagName === "BUY-BUTTON") new MutationObserver(quantidade).observe(btnCompra, { attributes: true, attributeFilter: ["data-quantity"] });
  quantidade();

  // ---- com o bundle (techecom) na caixa, a barra mostra a oferta escolhida:
  // nome, % OFF, "+N itens" do compre junto e o total com o riscado, lidos do
  // proprio bundle (que recalcula o total a cada troca). So le e escreve texto.
  var bundle = $("main-product .tc-bundle");
  function barraBundle() {
    var inp = bundle.querySelector(".tc-offer__input:checked"), of = inp && inp.closest(".tc-offer");
    if (!of) return;
    var nome = of.querySelector(".tc-offer-title"), extras = bundle.querySelectorAll(".tc2cj__check:checked").length;
    var fim = bundle.querySelector(".tc-total-final"), de = bundle.querySelector(".tc-total-base");
    $$("[data-barra-qtd]").forEach(function (el) { el.textContent = (nome ? nome.textContent.trim() : "") + (extras ? " + " + extras + (extras > 1 ? " itens" : " item") : ""); });
    $$(".ac-barra__off").forEach(function (el) { var d = +of.dataset.disc || 0; el.hidden = !d; if (d) el.textContent = d + "% OFF"; });
    $$("[data-barra-valores]").forEach(function (el) {
      if (fim && fim.textContent.trim()) $("[data-barra-preco]", el).textContent = fim.textContent.trim();
      var s = $("[data-barra-de]", el); if (s) { var t = de && de.style.display !== "none" ? de.textContent.trim() : ""; s.textContent = t; s.hidden = !t; }
    });
  }
  if (bundle) {
    var total = bundle.querySelector(".tc-total");
    if (total) new MutationObserver(barraBundle).observe(total, { subtree: true, childList: true, characterData: true });
    bundle.addEventListener("change", function () { setTimeout(barraBundle, 0); });
    barraBundle();
  }

  // ---- kits: o botao escolhe no bundle a oferta de mesma quantidade e leva ate a caixa
  $$("[data-kit-qtd]", raiz).forEach(function (b) {
    b.addEventListener("click", function () {
      var alvo = null;
      if (bundle) $$(".tc-offer", bundle).forEach(function (o) { if (String(o.dataset.qty) === String(b.dataset.kitQtd)) alvo = o; });
      var inp = alvo && alvo.querySelector(".tc-offer__input");
      if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event("change", { bubbles: true })); }
      var foco = alvo || btnCompra;
      if (!foco) return;
      foco.scrollIntoView({ behavior: menos ? "auto" : "smooth", block: "center" });
      if (!menos && foco.animate) foco.animate([{ transform: "scale(1)" }, { transform: "scale(1.03)" }, { transform: "scale(1)" }], { duration: 700, delay: 500, easing: "cubic-bezier(0.16,1,0.3,1)" });
    });
  });

  // ---- protocolos: tocar numa combinacao troca a foto (desfoque rapido)
  $$("[data-proto-raiz]", raiz).forEach(function (pr) {
    var img = $("[data-proto-img]", pr), ops = $$("[data-proto-foto]", pr);
    ops.forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.getAttribute("aria-selected") === "true") return;
        ops.forEach(function (o) { o.setAttribute("aria-selected", String(o === b)); });
        var troca = function () { if (b.dataset.protoFoto) img.src = b.dataset.protoFoto; img.alt = b.dataset.protoAlt || ""; };
        if (menos || !img.animate) { troca(); return; }
        img.animate([{ opacity: 1, filter: "blur(0)" }, { opacity: 0, filter: "blur(10px)" }], { duration: 180, fill: "forwards" }).onfinish = function () {
          troca(); img.animate([{ opacity: 0, filter: "blur(10px)", transform: "scale(1.03)" }, { opacity: 1, filter: "blur(0)", transform: "none" }], { duration: 560, easing: "cubic-bezier(0.16,1,0.3,1)", fill: "forwards" });
        };
      });
    });
  });

  // ---- stories da caixa de compra (componente do PDRN): tocam mudos no
  // circulo com a faixa na tela; o circulo usa o trecho curto e leve
  var faixa = $("[data-stories]");
  if (faixa && anima) {
    new IntersectionObserver(function (es) {
      var dentro = es[0].isIntersecting;
      // aneis so giram com a faixa na tela: girando fora dela, sujavam o estilo a cada
      // quadro e cada leitura de layout (Clarity, a cada rolagem) pagava o recalculo
      faixa.classList.toggle("na-tela", dentro);
      $$(".story video", faixa).forEach(function (v) {
        if (dentro) {
          if (!v.src) {
            var it = v.closest(".story"); v.src = it.dataset.circulo || it.dataset.src;
            // circulo leve (480p) que nao existe: volta para o video inteiro
            if (it.dataset.circulo && it.dataset.circulo !== it.dataset.src) v.addEventListener("error", function () { v.src = it.dataset.src; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }, { once: true });
          }
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else v.pause();
      });
    }, { threshold: 0.2 }).observe(faixa);
  }

  // ---- os dois grupos de video: os 4 stories e os 4 cartoes da secao; cada
  // um abre o player com a propria sequencia
  var grupos = [$$(".ac-bloco .story"), $$("[data-video]", raiz)];

  // ---- o player (o mesmo do PDRN)
  var st = $("[data-st]");
  if (st) {
  var video = $("[data-st-video]"), barras = $("[data-st-barras]"), palco = $("[data-st-palco]");
  var itens = [], n = 0, atual = 0, raf = 0, mudo = false, seg = null, pausouToque = false, fills = [];
  function usaGrupo(g) {
    itens = g; n = g.length; barras.textContent = "";
    g.forEach(function () { var s = document.createElement("span"); s.className = "st__barra"; s.appendChild(document.createElement("i")); barras.appendChild(s); });
    fills = $$(".st__barra i", barras);
  }
  function pintaSt() {
    var d = video.duration, t = video.currentTime;
    fills.forEach(function (f, k) { f.style.width = k < atual ? "100%" : k > atual ? "0%" : (d ? Math.min(100, t / d * 100) + "%" : "0%"); });
    raf = requestAnimationFrame(pintaSt);
  }
  function som() { $("[data-som-on]", st).toggleAttribute("hidden", mudo); $("[data-som-off]", st).toggleAttribute("hidden", !mudo); $("[data-st-som]", st).setAttribute("aria-label", mudo ? "Ligar o som" : "Tirar o som"); }
  function mostra(i) {
    if (i < 0) i = 0;
    if (i >= n) { fecha(); return; }
    atual = i; var it = itens[i];
    video.src = it.dataset.src; video.poster = it.dataset.capa; video.muted = mudo;
    $("[data-st-nome]", st).textContent = it.dataset.nome; $("[data-st-avatar]", st).src = it.dataset.capa;
    it.classList.add("visto"); st.classList.remove("pausado");
    var p = video.play(); if (p && p.catch) p.catch(function () { mudo = true; video.muted = true; som(); video.play().catch(function () {}); });
  }
  function abre(g, i) {
    usaGrupo(g);
    if (!st.showModal) { window.open(itens[i].dataset.src, "_blank", "noopener"); return; }
    st.showModal(); document.documentElement.style.overflow = "hidden"; som(); mostra(i);
    cancelAnimationFrame(raf); raf = requestAnimationFrame(pintaSt);
  }
  function solta() { cancelAnimationFrame(raf); video.pause(); video.removeAttribute("src"); video.load(); document.documentElement.style.overflow = ""; }
  function fecha() { if (st.open) st.close(); solta(); }
  grupos.forEach(function (g) { g.forEach(function (it, i) { it.addEventListener("click", function () { abre(g, i); }); }); });
  video.addEventListener("ended", function () { mostra(atual + 1); });
  $("[data-st-ant]", st).addEventListener("click", function () { mostra(atual - 1); });
  $("[data-st-prox]", st).addEventListener("click", function () { mostra(atual + 1); });
  $("[data-st-fechar]", st).addEventListener("click", fecha);
  $("[data-st-som]", st).addEventListener("click", function () { mudo = !mudo; video.muted = mudo; som(); });
  st.addEventListener("cancel", solta); st.addEventListener("close", solta);
  st.addEventListener("click", function (e) { if (e.target === st) fecha(); });
  st.addEventListener("keydown", function (e) {
    if (e.key === "ArrowRight") { e.preventDefault(); mostra(atual + 1); }
    else if (e.key === "ArrowLeft") { e.preventDefault(); mostra(atual - 1); }
    else if (e.key === " ") { e.preventDefault(); if (video.paused) { video.play(); st.classList.remove("pausado"); } else { video.pause(); st.classList.add("pausado"); } }
  });
  var y0 = 0, x0 = 0, zona = 0;
  palco.addEventListener("pointerdown", function (e) {
    var z = e.target.closest && e.target.closest("[data-zona]"); if (!z) return;
    zona = +z.dataset.zona; if (palco.setPointerCapture) palco.setPointerCapture(e.pointerId);
    y0 = e.clientY; x0 = e.clientX; pausouToque = false;
    seg = setTimeout(function () { pausouToque = true; video.pause(); st.classList.add("pausado"); }, 220);
  });
  palco.addEventListener("pointerup", function (e) {
    if (!zona) return; clearTimeout(seg);
    var dy = e.clientY - y0, dx = e.clientX - x0, z = zona; zona = 0;
    if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { fecha(); return; }
    if (pausouToque) { video.play(); st.classList.remove("pausado"); return; }
    if (Math.abs(dx) > 50) { mostra(atual + (dx < 0 ? 1 : -1)); return; }
    mostra(atual + z);
  });
  palco.addEventListener("pointercancel", function () { clearTimeout(seg); zona = 0; if (pausouToque) { video.play(); st.classList.remove("pausado"); } });
  }

  // ---- antes e depois: evolucao (arrastar funde as 4 fotos) + pares
  var evo = $("[data-evolucao]", raiz);
  if (evo) {
    var fotos = $$(".ad__fotos img", evo), faixaR = $("[data-evolucao-range]", evo), rotulo = $("[data-evolucao-rotulo]", evo), trilhoEvo = $("[data-evolucao-trilho]", evo);
    var pinta = function () {
      var v = +faixaR.value;
      fotos.forEach(function (im, k) { if (k) im.style.opacity = Math.max(0, Math.min(1, v - (k - 1))).toFixed(3); });
      trilhoEvo.style.setProperty("--p", (v / 3).toFixed(4));
      var txt = v < 0.5 ? "Antes" : v > 2.5 ? "Depois" : "Durante a rotina";
      rotulo.textContent = txt; faixaR.setAttribute("aria-valuetext", txt);
    };
    faixaR.addEventListener("input", function () { faixaR.dataset.mexeu = "1"; pinta(); });
    pinta();
    // ao aparecer, mostra sozinho uma vez o caminho de antes a depois
    if (anima) new IntersectionObserver(function (es, o) {
      if (!es[0].isIntersecting) return; o.disconnect();
      var t0 = null, dur = 2600;
      var passo = function (t) {
        if (faixaR.dataset.mexeu) return;
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur), e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        faixaR.value = (3 * e).toFixed(2); pinta();
        if (p < 1) requestAnimationFrame(passo);
      };
      setTimeout(function () { requestAnimationFrame(passo); }, 500);
    }, { threshold: 0.6 }).observe(evo);
  }
  // pares: um clique em qualquer ponto do cartao (foto ou alternador) troca
  // Antes <-> Depois; os botoes seguem focaveis e marcam o lado atual
  $$("[data-par]", raiz).forEach(function (par) {
    var botoes = $$("button", par);
    par.addEventListener("click", function () {
      var dep = !par.classList.contains("depois");
      par.classList.toggle("depois", dep);
      botoes.forEach(function (o) { o.setAttribute("aria-pressed", String((o.dataset.lado === "depois") === dep)); });
    });
  });
})();
